import React, { Component, Fragment } from 'react';
import queryString from 'query-string';
import { NewItemIcon } from '../../../Assets/Navigation/NavigationIcons';
import { routesPath } from '../../Navigation/NavigationUtils';
// import ItemImage from '../../../Components/Onboarding/Diagrams/ItemImage'
import ItemFlowDiagram from '../../../Components/Onboarding/Diagrams/ItemFlowDiagram';
import { restRequest } from '../../../Helpers/RequestHelper';
import { formatNumber } from '../../../Helpers/FormatNumber';
// import { HorizontalColumnJoinICON } from '../../../Components/ListTable/ListTableColumnJoin'
import Alert from '../../../Components/Alert/Alert';
import HeaderWrapper from '../../../Components/HeaderWrapper/HeaderWrapper';
import ListTable from '../../../Components/ListTable/ListTable';
import Onboarding from '../../../Components/Onboarding/InitialOnboardingScreen';
import ListTableImageColumn from '../../../Components/ListTable/ListTableImageColumn';
import CheckedMenu, {
  Button,
  ButtonLink,
  Options,
} from '../../../Components/CheckedMenu/CheckedMenu';
import SearchResult from '../../../Components/SearchBar/SearchResult';
import CustomModal from '../../../Components/CustomModal/CustomModal';
import Export from '../../../Components/Export/Export';
import './ItemList.css';
//import Onboarding from '../../../Components/Onboarding/Onboarding'
// import {BackorderIcon, DropshipIcon} from "../../../Assets/List/ListIcons";
// import getStatusColor from "../../../Helpers/GetStatusColor";
import {
  removeValueFromLS,
  getObjFromLS,
  setObjInLS,
  getStringValueFromLS,
} from '../../../Helpers/LocalStorage';
import ItemDetails from '../../../Pages/Items/ItemDetails';
import AddItem from '../../../Pages/Items/AddItem';
import EditItem from '../../../Pages/Items/EditItem';
import ExportIcon from '../../../Assets/General/ExportIcon';
import CloneIcon from '../../../Assets/General/CloneIcon';
import EditIcon from '../../../Assets/General/EditIcon';
import DeleteIcon from '../../../Assets/General/DeleteIcon';
import ActiveIcon from '../../../Assets/General/ActiveIcon';
import InactiveIcon from '../../../Assets/General/InactiveIcon';
// import EmptyTable from '../../../Components/ListTable/EmptyTable';
import ImportIcon from '../../../Assets/General/ImportIcon';
import { checkError } from '../../../Helpers/AuthHelper';
import AccessDenied from '../../../Components/AccessDenied/AccessDenied';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';

class ItemList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
      dataExpanded: [],
      showExportModal: false,
      organizationCurrency: {},
      store_connection: {},

      totalPage: 1,
      currentPage: 1,
      viewPerPage: 20,
      totalRecords: 20,
      itemId: null,
      currentFilter: 'all',
      orderBy: 'asc',
      sortFilter: 'name',
      preference: {},
      search: '',
      accessDenied: false,
      disableExportBtn: false,
    };
    this.getID = this.getID.bind(this);
  }

  filterOptions = [
    {
      id: 'none',
      label: this.props.t('Items.status'),
      type: 'tagline',
    },
    {
      id: 'all',
      label: this.props.t('Items.filters.all'),
      type: 'link',
      onClick: () => this.generateRoute({ filter: 'all', page: 1 }),
    },
    {
      id: 'active',
      label: this.props.t('Items.filters.active'),
      type: 'link',
      onClick: () => this.generateRoute({ filter: 'active', page: 1 }),
    },
    {
      id: 'inactive',
      label: this.props.t('Items.filters.inactive'),
      type: 'link',
      onClick: () => this.generateRoute({ filter: 'inactive', page: 1 }),
    },
    {
      id: 'lowstock',
      label: this.props.t('Items.filters.low_stock'),
      type: 'link',
      onClick: () => this.generateRoute({ filter: 'lowstock', page: 1 }),
    },
    {
      id: 'market_place',
      label: this.props.t('Items.filters.market_place'),
      type: 'link',
      onClick: () => this.generateRoute({ filter: 'market_place', page: 1 }),
    },
    {
      id: 'woocom',
      label: this.props.t('Items.filters.woo-commerce'),
      type: 'link',
      onClick: () => this.generateRoute({ filter: 'woocom', page: 1 }),
    },
    {
      id: 'shopify',
      label: this.props.t('Items.filters.shopify'),
      type: 'link',
      onClick: () => this.generateRoute({ filter: 'shopify', page: 1 }),
    },
    {
      id: 'tracked',
      label: this.props.t('Items.filters.tracked'),
      type: 'link',
      onClick: () => this.generateRoute({ filter: 'tracked', page: 1 }),
    },
    {
      id: 'untracked',
      label: this.props.t('Items.filters.untracked'),
      type: 'link',
      onClick: () => this.generateRoute({ filter: 'untracked', page: 1 }),
    } /*,
    {
      id: 'inventory',
      label: 'Inventory',
      type: 'link',
      onClick: () => this.generateRoute({ filter: 'inventory', page: 1 })
    },
    {
      id: 'noninventory',
      label: 'Non-Inventory',
      type: 'link',
      onClick: () => this.generateRoute({ filter: 'noninventory', page: 1 })
    },
    {
      id: 'services',
      label: 'Services',
      type: 'link',
      onClick: () => this.generateRoute({ filter: 'services', page: 1 })
    }*/,
  ];

  importExportOptions = [
    {
      label: this.props.t('Items.import_items'),
      icon: <ImportIcon />,
      onClick: () => {
        this.props.history.push('/items/import');
      },
      disabled: () => this.hasCreatePermission(),
    },
    {
      label: this.props.t('Items.export_items'),
      icon: <ExportIcon />,
      onClick: () => this.openExportModal(),
      disabled: () =>
        !this.hasViewPermission('item') ||
        this.state.disableExportBtn ||
        JSON.parse(localStorage.getItem('exportBtn')),
    },
  ];

  sortOptions = [
    {
      id: 'name',
      label: this.props.t('Items.name'),
      type: 'link',
      onClick: () => this.generateRoute({ ...this.prepareSortFilter('name') }),
    },
    {
      id: 'created_at',
      label: this.props.t('Items.created_time'),
      type: 'link',
      onClick: () =>
        this.generateRoute({ ...this.prepareSortFilter('created_at') }),
    },
    {
      id: 'sku',
      label: this.props.t('Items.sku'),
      type: 'link',
      onClick: () => this.generateRoute({ ...this.prepareSortFilter('sku') }),
    },
    {
      id: 'stock',
      label: this.props.t('Items.stock'),
      type: 'link',
      onClick: () => this.generateRoute({ ...this.prepareSortFilter('stock') }),
    },
    /*{
      id: 'purchase_unit_price',
      label: 'Purchase Price',
      type: 'link',
      onClick: () => this.generateRoute({ ...this.prepareSortFilter('purchase_unit_price') })
    },*/
    {
      id: 'sales_unit_price',
      label: this.props.t('Items.selling_price'),
      type: 'link',
      onClick: () =>
        this.generateRoute({ ...this.prepareSortFilter('sales_unit_price') }),
    },
    {
      id: 'reorder_level',
      label: this.props.t('Items.reorder_level'),
      type: 'link',
      onClick: () =>
        this.generateRoute({ ...this.prepareSortFilter('reorder_level') }),
    },
  ];

  componentDidMount() {
    document.title = this.props.t('Items.view_items');
    this.fetchDataWithQueryString();
  }

  componentDidUpdate() {
    this.handleOnUpdateQueryString();
  }
  handleOnUpdateQueryString() {
    const { filter, page, sort, orderBy, view, search } =
      this.parseQueryString();
    if (filter !== this.state.currentFilter) {
      this.setState(
        {
          currentFilter: filter,
        },
        () => this.fetchData()
      );
    }
    if (sort !== this.state.sortFilter) {
      this.setState(
        {
          sortFilter: sort,
        },
        () => this.fetchData()
      );
    }
    if (orderBy !== this.state.orderBy) {
      this.setState(
        {
          orderBy: orderBy,
        },
        () => this.fetchData()
      );
    }
    if (page !== this.state.currentPage) {
      sessionStorage.setItem('current_page', parseInt(page));
      this.setState(
        {
          currentPage: parseInt(page),
        },
        () => this.fetchData()
      );
    }
    if (view !== this.state.viewPerPage) {
      this.handleResetCheckbox(true);
      sessionStorage.setItem('view', parseInt(view));
      this.setState(
        {
          viewPerPage: parseInt(view),
        },
        () => this.fetchData()
      );
    }
    if (search !== this.state.search) {
      this.setState({ search: search, bulkSelectedData: [] }, () =>
        this.fetchData()
      );
    }
  }

  MarketFilterOptions() {
    const { wocom, shopify } = this.state.store_connection;
    let array;
    if (wocom && !shopify) {
      array = this.filterOptions.filter((option) => {
        return option.id !== 'shopify' && option.id !== 'market_place';
      });
    } else if (!wocom && shopify) {
      array = this.filterOptions.filter((option) => {
        return option.id !== 'woocom' && option.id !== 'market_place';
      });
    } else if (!wocom && !shopify) {
      array = this.filterOptions.filter((option) => {
        return (
          option.id !== 'woocom' &&
          option.id !== 'shopify' &&
          option.id !== 'market_place'
        );
      });
    } else {
      return;
    }

    this.filterOptions = array;
  }

  fetchDataWithQueryString() {
    const { filter, page, sort, orderBy, view, search } =
      this.parseQueryString();
    this.setState(
      {
        sortFilter: sort,
        currentFilter: filter,
        currentPage: parseInt(page),
        orderBy: orderBy,
        viewPerPage: parseInt(view),
        search: search,
      },
      () => this.fetchData()
    );
  }

  parseQueryString() {
    const query = queryString.parse(this.props.location.search);
    let filter = '';
    switch (query.filter) {
      case 'all':
      case 'active':
      case 'inactive':
      case 'lowstock':
      case 'market_place':
      case 'woocom':
      case 'shopify':
      case 'tracked':
      case 'untracked':
        filter = query.filter;
        break;
      default:
        filter = 'all';
    }

    let sort = '';
    switch (query.sort) {
      case 'name':
      case 'created_at':
      case 'sku':
      case 'stock':
      case 'sales_unit_price':
      case 'reorder_level':
        sort = query.sort;
        break;
      case 'accounting_stock':
      case 'physical_stock':
        sort = 'stock';
        break;
      default:
        sort = 'name';
    }

    let orderBy = '';
    switch (query.orderBy) {
      case 'asc':
      case 'desc':
        orderBy = query.orderBy;
        break;
      default:
        orderBy = 'asc';
    }

    let page = parseInt(query.page);
    if (!page) page = 1;
    let view = parseInt(query.view);
    if (!view) view = 20;

    let search = query.search;
    if (!search) search = '';

    return {
      filter,
      page,
      sort,
      orderBy,
      view,
      search,
    };
  }

  fetchData = async () => {
    this.setState({ loading: true });

    await this.fetchItemsList();

    this.setState({ loading: false });
  };

  fetchItemsList() {
    sessionStorage.setItem('view', parseInt(this.state.viewPerPage));
    sessionStorage.setItem('current_page', parseInt(this.state.currentPage));
    let searchkey = this.state.search.replace('&', '%26');
    return restRequest(
      'get',
      `items?filter=${this.state.currentFilter}&page=${this.state.currentPage}&sort_by=${this.state.sortFilter}&order_by=${this.state.orderBy}&view=${this.state.viewPerPage}&search=${searchkey}`
    )
      .then((res) => {
        const baseCurrency = res.base_currency;
        sessionStorage.setItem('total_items', parseInt(res.items.data.length));
        let obj = {
          prevId: null,
          id: res.items.data[0] && res.items.data[0].id,
          nextId: res.items.data[1] && res.items.data[1].id,
          moduleName: 'items',
          urlPath: window.location.pathname,
          queryParam: window.location.search,
        };
        let dataFromLS = getObjFromLS('module');
        if (dataFromLS && dataFromLS.moduleName !== 'items') {
          sessionStorage.setItem('fullscreen', true);
          sessionStorage.setItem('once', true);
          removeValueFromLS('module');
          if (res.items.data[0]) {
            setObjInLS('module', obj);
          }
        }
        if (!res.items.data[0]) {
          removeValueFromLS('module');
        }
        if (!dataFromLS || dataFromLS.action === 'add') {
          if (res.items.data[0]) {
            setObjInLS('module', obj);
          }
        } else if (dataFromLS.action === 'bulkdelete') {
          if (res.items.data[0]) {
            setObjInLS('module', { ...obj, lolo: 'no' });
          }
        } else if (
          dataFromLS &&
          dataFromLS.moduleName === 'items' &&
          dataFromLS.queryParam !== window.location.search
        ) {
          if (res.items.data[0]) {
            setObjInLS('module', obj);
          }
        }
        if (!res.items?.data?.length) {
          sessionStorage.setItem('fullscreen', true);
          setObjInLS('module', obj);
        }
        this.setState(
          {
            data: this.prepareDataForTableCollapsed(
              res.items.data,
              res.stock_preference,
              baseCurrency
            ),
            dataExpanded: this.prepareDataForTable(
              res.items.data,
              res.stock_preference,
              baseCurrency
            ),
            totalPage: res.items.last_page,
            totalRecords: res.items.total,
            organizationCurrency: baseCurrency,
            preference: res.stock_preference,
            store_connection: res.store_connection,
          },
          () => {
            this.MarketFilterOptions();
            this.setState({
              mainLoading: false,
            });
          }
        );
      })
      .catch((error) => {
        this.setState({
          accessDenied: checkError(error, this.props.handleToast),
        });
        //this.props.handleToast(error, "error")
      });
  }

  prepareDataForTable(data, preference, baseCurrency) {
    return data.map((item) => ({
      id: item.id,
      [this.props.t('Items.item')]: {
        id: 'name',
        sortable: true,
        market_place: item?.association,
        // getValue: () => <ListTableImageColumn name={item.name} sku={item.sku} images={item.images} />
        getValue: () => (
          <ListTableImageColumn name={item.name} images={item.images} />
        ),
      },
      // 'Created Date': {
      //   id: 'created_at',
      //   sortable: true,
      //   getValue: function () { return item[this.id] }
      // },

      [this.props.t('Items.sku')]: {
        id: 'sku',
        sortable: true,
        getValue: function () {
          return item[this.id];
        },
      },
      [this.props.t('Items.stock')]: {
        id: 'stock',
        sortable: true,
        alignRight: true,
        getValue: function () {
          if (item.inventory_type === 'noninventory') {
            return '-';
          } else if (
            parseFloat(
              item[
                `${
                  preference.preferences.physical
                    ? 'physical_stock'
                    : 'accounting_stock'
                }`
              ]
            ) < parseFloat(item.reorder_level)
          ) {
            return (
              <Fragment>
                <div className={'list-table--link-error'}>
                  {formatNumber(
                    item[
                      `${
                        preference.preferences.physical
                          ? 'physical_stock'
                          : 'accounting_stock'
                      }`
                    ]
                  )}
                </div>
                <div className="small-td-info list-table--link-error">
                  {item.unit}
                </div>
              </Fragment>
            );
          } else {
            return (
              <Fragment>
                {formatNumber(
                  item[
                    `${
                      preference.preferences.physical
                        ? 'physical_stock'
                        : 'accounting_stock'
                    }`
                  ]
                )}
                <div className="small-td-info">{item.unit}</div>
              </Fragment>
            );
          }
        },
      },
      /*'Status': {
        id: 'status',
        alignRight: true,
        hideStatusColor: true,
        getValue: function () {
          const Icons = []
          const tooltips = []
          // Added for clone indication
          if (item.clone_status === 1) {
            Icons.push(CloneIcon)
            tooltips.push('Clone Item')
          }
          return(
            <HorizontalColumnJoinICONd
              Icons={Icons}
              tooltips={tooltips}
            />
          )
        }
       },
      'Reorder': {
        id: 'reorder_level',
        alignRight: true,
        getValue: function () { return formatNumber(item[this.id]) }
      },*/
      /*'Purchase Price': {
        id: 'purchase_unit_price',
        sortable: true,
        alignRight: true,
        getValue: function () {
          return `${baseCurrency.symbol}${formatNumber(item[this.id])}`
        }
      },*/
      [this.props.t('Items.selling_price')]: {
        id: 'sales_unit_price',
        alignRight: true,
        sortable: true,
        getValue: function () {
          return (
            `${baseCurrency.symbol}` + parseFloat(item[this.id])?.toFixed(2)
          );
        },
      },
      [this.props.t('Items.reorder_level')]: {
        id: 'reorder_level',
        alignRight: true,
        sortable: true,
        getValue: function () {
          return item[this.id];
        },
      },
      // not displayable
      additional: {
        isActive: item.is_active,
      },
    }));
  }

  prepareDataForTableCollapsed(data, preference, baseCurrency) {
    return data.map((item) => ({
      id: item.id,
      Item: {
        id: 'name',
        sortable: true,
        // getValue: () => <ListTableImageColumn name={item.name} sku={item.sku} images={item.images} />
        getValue: () => (
          <ListTableImageColumn name={item.name} images={item.images} />
        ),
      },
      // not displayable
      additional: {
        isActive: item.is_active,
      },
    }));
  }

  // check status whether its active or not
  checkActiveStatus = (id) =>
    this.state.data.find((one) => {
      return one.id === id;
    }).additional.isActive;

  // render action menu for single selected data
  renderSingleActionMenu = () => {
    const id = this.state.bulkSelectedData[0];
    const isActive = this.checkActiveStatus(id);
    const [, hasEditPermission, hasDeletePermission] = this.hasPermission(
      'item',
      'All'
    );
    return (
      <CheckedMenu count={this.state.bulkSelectedData.length}>
        <ButtonLink
          enable={hasEditPermission}
          to={`/items/edit/${this.state.bulkSelectedData[0]}`}
          type="edit"
        />
        <Button
          enable={hasDeletePermission}
          handleClick={() =>
            this.openDeleteModal(this.state.bulkSelectedData[0])
          }
          type="delete"
        />
        <Button
          enable={hasEditPermission}
          // label={`Mark as ${isActive ? 'inactive' : 'active'}`}
          handleClick={() =>
            this.toggleActive(
              this.state.bulkSelectedData[0],
              !isActive ? 'active' : 'inactive'
            )
          }
          type={isActive ? 'inactive' : 'active'}
        />
        <Button handleClick={() => this.exportCurrentView()} type="export" />
      </CheckedMenu>
    );
  };

  exportCurrentView = () => {
    restRequest('post', `items/exportcurrentview`, {
      item_ids: this.state.bulkSelectedData,
    })
      .then((res) => {
        let csvFile = 'data:text/csv;charset=utf-8,' + res;
        let encodedUri = encodeURI(csvFile);
        let link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', `items.csv`);
        document.body.appendChild(link);
        link.click();
        this.props.handleToast(t('common.items_exported_successfully'), 'success');
        this.setState({ bulkSelectedData: [] });
      })
      .catch((error) => {
        checkError(error, this.props.handleToast);
        //this.props.handleToast(error, 'error')
      });
  };

  populateConditionalOptions() {
    const options = [
      {
        label: 'Mark as Active',
        onClick: () => this.toggleAllActive('active'),
      },
      {
        label: 'Mark as Inactive',
        onClick: () => this.toggleAllActive('inactive'),
      },
      {
        label: 'Export Selected',
        onClick: () => this.exportCurrentView(),
        disabled: () => !this.hasViewPermission('item'),
      },
    ];
    return options;
  }

  // render action menu for multiple selected data
  renderMultipleActionMenu = () => {
    const [, hasEditPermission, hasDeletePermission] = this.hasPermission(
      'item',
      'All'
    );
    const options = this.populateConditionalOptions();
    return (
      <CheckedMenu count={this.state.bulkSelectedData.length}>
        <Button
          enable={hasDeletePermission}
          handleClick={this.openBulkDeleteModal}
          type="delete"
        />
        <Options
          enable={hasEditPermission && !!options.length}
          options={options}
        />
      </CheckedMenu>
    );
  };
  hasCreatePermission() {
    const [hasCreatePermission] = this.hasPermission('item', 'All');
    return !hasCreatePermission;
  }
  hasEditPermission() {
    const hasEditPermission = this.hasPermission('item', 'Edit');
    return hasEditPermission;
  }
  hasDeltePermission() {
    const hasDeltePermission = this.hasPermission('item', 'Delete');
    return hasDeltePermission;
  }

  prepareRowOptions() {
    const rowOptions = [
      {
        label: this.props.t('Items.edit'),
        type: this.hasEditPermission() && 'link',
        icon: EditIcon,
        onClick: (id) => `items/edit/${id}`,
        disabled: () => !this.hasEditPermission(),
      },
      {
        label: this.props.t('Items.clone'),
        // type: 'link',
        icon: CloneIcon,
        onClick: (id) => this.props.history.push(`items/clone/${id}`),
        disabled: () => this.hasCreatePermission(),
      },
      {
        label: this.props.t('Items.delete'),
        icon: DeleteIcon,
        onClick: this.openDeleteModal,
        disabled: () => !this.hasDeltePermission(),
      },
      {
        label: this.props.t('Items.mark_inactive'),
        icon: InactiveIcon,
        disabled: (id) =>
          !this.hasEditPermission() ? true : !this.checkActiveStatus(id),
        onClick: (id) => this.toggleActive(id, 'inactive'),
      },
      {
        label: this.props.t('Items.mark_active'),
        icon: ActiveIcon,
        disabled: (id) =>
          !this.hasEditPermission() ? true : this.checkActiveStatus(id),
        onClick: (id) => this.toggleActive(id, 'active'),
      },
    ];

    return rowOptions;
  }

  renderTable() {
    const {
      data,
      dataExpanded,
      bulkSelectedData,
      sortFilter,
      orderBy,
      //loading,
      accessDenied,
      mainLoading,
    } = this.state;
    if (accessDenied) {
      return <AccessDenied />;
    }
    if (!mainLoading) {
      if (this.checkIfOnboarding()) {
        let obj = {
          prevId: null,
          id: null,
          nextId: null,
          moduleName: 'items',
          urlPath: window.location.pathname,
          queryParam: window.location.search,
        };
        setObjInLS('module', obj);
        return (
          <Onboarding
            name="Item"
            FlowDiagram={ItemFlowDiagram}
            videoFrame={
              <iframe
                width="700"
                height="500"
                src="https://www.youtube.com/embed/nzA65-Au0Uc"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            }
            DisplayIcon={NewItemIcon}
            headerTitle={this.props.t('Items.items')}
            description={this.props.t('Items.create_manage_adjust')}
            buttonLabel={this.props.t('Items.create_item')}
            buttonLink="/items/add"
            secondaryButtonLabel={this.props.t('Items.import_items')}
            secondaryButtonLink="/items/import"
          />
        );
      }
    }
    let fullscreen = getStringValueFromLS('fullscreen');
    return (
      <ListTable
        className={`item-listing-woocom ${
          fullscreen === 'true' ? 'fullscreen ' : 'salesorder_listing'
        } ${orderBy === 'asc' ? 'so-asc-active' : 'so-desc-active'} `}
        data={fullscreen === 'true' ? dataExpanded : data}
        selectedData={bulkSelectedData}
        rowOptions={this.prepareRowOptions()}
        linkTo="/items"
        sortFilter={sortFilter}
        orderBy={orderBy}
        loading={mainLoading}
        isBlur="isActive"
        generateRoute={this.generateRoute}
        handleCheckAll={this.handleCheckAll}
        handleCheckSingle={this.handleCheckSingle}
        getID={this.getID}
        moduleName="items"
        totalRecords={this.state.totalRecords}
      />
    );
  }

  renderSearchDetails() {
    const { search } = this.state;
    if (search) {
      return (
        <Alert
          className="full-width green"
          id="elasticSearch"
          title={this.props.t('elastic_search_alert.search_criteria')}
          linkTo={routesPath.items}
        >
          <SearchResult
            criterias={[
              'Name',
              'SKU',
              'UPC',
              'MPN',
              'EAN',
              'ISBN',
              'Manufacturer',
              'Brand',
            ]}
            searchKey={search.replace('%26', '&')}
          />
        </Alert>
      );
    }
    return null;
  }

  openExportModal() {
    this.setState({ showExportModal: true });
  }

  closeModal = () => {
    this.setState({ showExportModal: false });
  };

  getID(prevId, id, nextId) {
    let obj = {
      id,
      prevId: prevId ? prevId : null,
      nextId: nextId ? nextId : null,
      moduleName: 'items',
      urlPath: window.location.pathname,
      queryParam: window.location.search,
    };
    setObjInLS('module', obj);
    this.setState({ itemId: id });
    // setValueInLS('id',id)
  }

  renderExportModal() {
    return (
      <CustomModal
        showModal={this.state.showExportModal}
        title={this.props.t('Items.export_items')}
        Icon={ExportIcon}
        onClose={this.closeModal}
        renderActions={false}
      >
        <Export
          name="Items"
          onCancel={this.closeModal}
          submitURL="items/export"
          handleToast={this.props.handleToast}
          disableExportBtn={this.state.disableExportBtn}
          setDisableExportBtn={(value) =>
            this.setState({ disableExportBtn: value })
          }
        />
      </CustomModal>
    );
  }

  render() {
    return (
      <Fragment>
        {this.renderExportModal()}
        {this.renderTable()}
      </Fragment>
    );
  }
}

export default withTranslation()(
  HeaderWrapper(
    ItemList,
    {
      name: 'Items.items',
      tableIcon: 'general_module_icon',
      Icon: NewItemIcon,
      baseUrl: 'items',
      deleteName: 'Items.item',
      deleteText: 'Item',
      buttonUrl: '/items/add',
      buttonLabel: 'Items.new_item',
      routeName: 'items',
      showDetailsComp: true,
      bypassLoadingState: false,
      permissionName: 'item',
    },
    ItemDetails,
    AddItem,
    EditItem
  )
);
